export default function selectStep(state = {}, action) {
  if (action.type === 'selectStep') {
    return action.step;
  }
  return state;
}